import React, { useMemo } from "react";
import logo from "./assets/logofinal-flat.png";
import "./StaticPageLayout.css";

export function useWeavevoI18n(i18n) {
  const lang = useMemo(() => {
    if (typeof navigator === "undefined") return "en";
    return (navigator.language || "").toLowerCase().startsWith("fr") ? "fr" : "en";
  }, []);

  const t = (key) => {
    const current = i18n?.[lang] || {};
    const fallback = i18n?.en || {};
    return current[key] || fallback[key] || key;
  };

  return { lang, t };
}

export default function StaticPageLayout({ title, children }) {
  return (
    <div className="wv-staticPage">
      <header className="wv-staticNav" aria-label="Weavevo public navigation">
        <a className="wv-staticBrand" href="/homeV2" aria-label="Weavevo home">
          <img src={logo} alt="Weavevo" />
          <span>weavevo</span>
        </a>

        <nav className="wv-staticMenu" aria-label="Home page sections">
          <a href="/homeV2#use-cases">Use Cases</a>
          <a href="/homeV2#technology">Technology</a>
          <a href="/homeV2#weavers">Weavers</a>
          <a className="wv-staticCta" href="/join-beta">Join Beta</a>
        </nav>
      </header>

      <main className="wv-staticMain">
        <article className="wv-staticCard">
          <a className="wv-staticBack" href="/homeV2">
            <i className="bi bi-arrow-left" aria-hidden="true" />
            Back to Weavevo
          </a>

          <h1>{title}</h1>
          <div className="wv-staticBody">{children}</div>
        </article>
      </main>

      <footer className="wv-staticFooter" aria-label="Weavevo legal and support footer">
        <div className="wv-staticFooterGrid">
          <div className="wv-staticFooterColumn">
            <h4><i className="bi bi-shield-check" aria-hidden="true" /> Legal</h4>
            <a href="/mentions-legales">Legal notice</a>
            <a href="/politique-confidentialite">Privacy policy</a>
            <a href="/cgu">Terms of use (ToS)</a>
            <a href="/accessibilite-rgpd">Accessibility & GDPR</a>
          </div>

          <div className="wv-staticFooterColumn">
            <h4><i className="bi bi-life-preserver" aria-hidden="true" /> Support</h4>
            <a href="/join-beta#support">Contact / Support</a>
          </div>
        </div>

        <div className="wv-staticFooterBottom">
          <span>© 2026 Weavevo. All rights reserved.</span>
        </div>
      </footer>
    </div>
  );
}
